module.exports = __webpack_public_path__ + "img/年货礼包.8ead0a9f.jpg";